import React from 'react';
import { Row, Col } from '@zendeskgarden/react-grid';
import { LG } from '@zendeskgarden/react-typography';
import { StyledLandingSolutions } from './OurFounder.styles.js';



const LandingSolutions = (props) => {
  return (
    <StyledLandingSolutions>
      
      <Row>
        <Col md={12} justifyCenter>
          <div>
            <Row>
              <Col size="auto" alignCenter justifyCenter>
                <div style={{display: 'block', margin: '0 15px', backgroundImage: "url(https://res.cloudinary.com/hbq7zoknx/image/upload/f_auto/v1604257457/image_copy_yruwsp.png)", backgroundPosition: 'center', backgroundSize: 'cover', width: 270, height: 270, borderRadius: '300px'}} />
              </Col>
              <Col size="auto">
                <LG scaled bold paddingTopMd navy light tag="h3">
                  About The Founder
                </LG>
                <LG style={{maxWidth: '650px'}} paddingTopMd navy light tag="h3">
                  Founder Mike Profeta installed the first super-conducting, whole-body Imaging magnet in this hemisphere. From there he was recruited to the research and development team where he helped found the MRI technologies that we use today.
                </LG>

                <LG style={{maxWidth: '650px'}} paddingTopMd navy light tag="h3">
                   He then mastered the art and physics of shielding and has been trusted ever since to build and maintain equipment rooms for some of the largest, most prestigious, hospitals in the world…hospitals that only want the best of the best.
                </LG>
                <LG style={{maxWidth: '650px'}} paddingTopMd navy light tag="h3">
                   He is one of the most respected minds in the industry and he has built MRT upon the foundations of his experience.
                </LG>
              </Col>
            </Row>
            
          </div>
          
        </Col>
      </Row>      
    </StyledLandingSolutions>

  )
}


export default LandingSolutions;
